import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Option = styled.div`
  font-size: 14px;
  padding: 4px 10px;
  color: #000;
`;
